/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Public_ChangelogInputs */

const en_us2_community_public_changelog = /** @type {(inputs: Community_Public_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every release on the site`)
};

const pt_br2_community_public_changelog = /** @type {(inputs: Community_Public_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as novidades no site`)
};

const es_419_community_public_changelog = /** @type {(inputs: Community_Public_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las versiones en el sitio`)
};

const pt_pt2_community_public_changelog = /** @type {(inputs: Community_Public_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as novidades no site`)
};

const fr_fr2_community_public_changelog = /** @type {(inputs: Community_Public_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les versions sur le site`)
};

const de_de2_community_public_changelog = /** @type {(inputs: Community_Public_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Versionen auf der Website`)
};

const it_it2_community_public_changelog = /** @type {(inputs: Community_Public_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le versioni sul sito`)
};

/**
* | output |
* | --- |
* | "Every release on the site" |
*
* @param {Community_Public_ChangelogInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_public_changelog = /** @type {((inputs?: Community_Public_ChangelogInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Public_ChangelogInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_public_changelog(inputs)
	if (locale === "es-419") return es_419_community_public_changelog(inputs)
	if (locale === "pt-PT") return pt_pt2_community_public_changelog(inputs)
	if (locale === "fr-FR") return fr_fr2_community_public_changelog(inputs)
	if (locale === "de-DE") return de_de2_community_public_changelog(inputs)
	if (locale === "it-IT") return it_it2_community_public_changelog(inputs)
	return en_us2_community_public_changelog(inputs)
});
export { community_public_changelog as "community.public_changelog" }